import React from 'react';
import styled from 'styled-components';

import useTranslation from 'hooks/use-translation';
import { StarRating } from 'components/reviews/star-rating';

type ProductTitleRatingProps = {
  avgRating?: number | null;
  reviewCount: number;
};

/** Compact rating shown under the product title: stars + numeric value + review count. */
export const ProductTitleRating = ({ avgRating, reviewCount }: ProductTitleRatingProps): JSX.Element | null => {
  const { t } = useTranslation();

  if (reviewCount <= 0) return null;

  return (
    <Row data-testid='product-title-rating'>
      {avgRating != null && (
        <>
          <StarRating value={avgRating} size={16} showValue />
          <Separator aria-hidden='true'>|</Separator>
        </>
      )}
      <Count>{t('product.reviews.count', '{{count}} Reviews', { count: reviewCount })}</Count>
    </Row>
  );
};

const Row = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-top: 12px;
`;

const Separator = styled.span`
  color: ${({ theme }) => theme.colors.grey[80]};
`;

const Count = styled.span`
  font-size: 13px;
  color: ${({ theme }) => theme.colors.grey[45]};
`;
